module.exports = __webpack_public_path__ + "e7228e880fcd78fde5ca24c505f2cb25.svg";